import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Auth = (props) => {
  const location = useLocation();
  const { darkMode } = useSelector((state) => state.global);
  const showNavbar = location.pathname === "/main";
  return (
    <>
      <div className={darkMode === true ? "bg-site-black" : "bg-site-white"}>
        {!showNavbar ? <Header /> : <div></div>}
        {props.children}
        <Footer />
      </div>
    </>
  );
};

export default Auth;
